var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      staticStyle: { "pointer-events": "auto" },
      attrs: {
        title: _vm.formData.id ? "修改" : "新增",
        visible: _vm.dialogFormVisible,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: function($event) {
          return _vm.resetForm("ruleForm")
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: {
            model: _vm.formData,
            rules: _vm.rules,
            "label-width": "150px"
          }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "lodingItem",
              attrs: { label: "产品绑定广告渠道", prop: "switch_id" }
            },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    filterable: "",
                    clearable: "",
                    placeholder: "选择自定义名称"
                  },
                  model: {
                    value: _vm.formData.switch_id,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "switch_id", $$v)
                    },
                    expression: "formData.switch_id"
                  }
                },
                _vm._l(_vm.callbackSwitchConfigData, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.custom_name, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { width: "100%", "margin-bottom": "0" } },
            [
              _c(
                "el-form-item",
                { staticClass: "lodingItem", attrs: { prop: "amountJson" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.addContent }
                    },
                    [_vm._v("添加拆分条件")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._l(_vm.formData.amountJson, function(domain, index) {
            return _c("div", { key: index + "k", staticClass: "paramsClass" }, [
              _c(
                "div",
                {
                  staticClass: "lodingItem-operationFrame flex",
                  staticStyle: {
                    "flex-direction": "column",
                    "justify-content": "start",
                    "align-items": "start"
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex", width: "100%" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "flex-1",
                          attrs: {
                            prop: "amountJson." + index + ".totalAmount",
                            rules: _vm.rules.totalAmount,
                            "label-width": "60px"
                          }
                        },
                        [
                          _c("el-input", {
                            staticClass: "operationFrame-entity",
                            attrs: { clearable: "", placeholder: "输入金额" },
                            model: {
                              value: domain.totalAmount,
                              callback: function($$v) {
                                _vm.$set(domain, "totalAmount", $$v)
                              },
                              expression: "domain.totalAmount"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { "padding-top": "6px" } },
                        [
                          _c("el-button", {
                            staticStyle: { margin: "0 10px 0" },
                            attrs: {
                              size: "mini",
                              type: "primary",
                              circle: "",
                              icon: "el-icon-plus"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.addAmountItem(domain)
                              }
                            }
                          }),
                          _c("el-button", {
                            staticStyle: { margin: "0 10px 0" },
                            attrs: {
                              size: "mini",
                              type: "danger",
                              circle: "",
                              icon: "el-icon-delete"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.removeContent(domain)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-wrap": "wrap",
                        width: "100%"
                      }
                    },
                    _vm._l(domain.amountList, function(item, idx) {
                      return _c(
                        "div",
                        {
                          key: idx + "k",
                          staticClass: "flex",
                          staticStyle: { width: "25%" }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "flex-1",
                              attrs: {
                                prop:
                                  "amountJson." +
                                  index +
                                  ".amountList." +
                                  idx +
                                  ".value",
                                rules: _vm.rules.value,
                                "label-width": "60px"
                              }
                            },
                            [
                              _c("el-input", {
                                staticClass: "operationFrame-entity",
                                attrs: { clearable: "" },
                                model: {
                                  value: item.value,
                                  callback: function($$v) {
                                    _vm.$set(item, "value", $$v)
                                  },
                                  expression: "item.value"
                                }
                              })
                            ],
                            1
                          ),
                          _c("el-button", {
                            staticStyle: { margin: "0 10px 24px 10px" },
                            attrs: {
                              size: "mini",
                              type: "danger",
                              circle: "",
                              icon: "el-icon-delete"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.removeItemContent(
                                  item,
                                  domain.amountList
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                ]
              )
            ])
          })
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  return _vm.resetForm("ruleForm")
                }
              }
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.dataFormSubmit("ruleForm")
                }
              }
            },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }